
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import { CONNECTOR_TYPES } from '@/vars/general'
import { login } from '@root/src/api/connectors/universeSoft'

const TASKS = [
    {
        title: 'Выполните инструкцию',
        body: 'Откройте <a href="http://help.dataheroes.pro/?slug=840-yunivers" target="_blank" rel="noopener noreferrer">инструкцию Universe Soft</a> и подготовьте данные подключения.',
    },
    {
        title: 'Заполните поля справа',
        body: 'Укажите URL, BasicAuth — u, BasicAuth — p, ApiKey и ApiPass.',
    },
    {
        title: 'Отправьте данные',
        body: 'После отправки мы проверим доступность API.',
    },
]

export default {
    name: 'UniverseSoftAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const validLogin = ref<boolean | null>(null)
        const loading = ref(false)
        const creds = ref({
            url: '',
            basicAuthU: '',
            basicAuthP: '',
            apiKey: '',
            apiPass: '',
        })

        const btnDisabled = computed(() =>
            Object.values(creds.value).some((v) => !String(v || '').trim())
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const credentials = {
                url: creds.value.url,
                user: creds.value.basicAuthU,
                password: creds.value.basicAuthP,
                apiKey: creds.value.apiKey,
                apiPass: creds.value.apiPass,
            }
            const projectId = root.$router.currentRoute.params.id
            const connector = await store.dispatch('project/createConnector', {
                projectId,
                connectorType: CONNECTOR_TYPES.universeSoft,
            })
            const isLogin = await login(connector, credentials)
            if (isLogin) {
                store.commit('project/setLoggedAddingConnector', connector)
                root.$parent.$emit('login')
            }
            validLogin.value = isLogin
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Войти',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            creds,
            validLogin,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
